// Analytics senders. Each function targets one vendor; track() is the default
// fan-out used across the app. Also exposed as window.trackEvent for inline ERB.

// GTM custom event — the marketer maps these to GA4 / Meta / etc. in the GTM UI.
export const trackGtm = (event, params = {}) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}

// Hotjar custom event (name only — Hotjar events carry no payload). Prod only.
export const trackHotjar = (event) => {
  if (typeof window.hj === "function") {
    window.hj("event", event)
  }
}

// GA4 / gtag command passthrough — pushes the command's arguments onto dataLayer,
// which gtag.js forwards to GA4. Used for "js", "config" and "event" commands. Most
// events reach GA4 through GTM (trackGtm) instead; this is the direct gtag path.
export function trackGa4() {
  window.dataLayer = window.dataLayer || []
  // biome-ignore lint/complexity/noArguments: gtag requires the arguments object, not an array
  window.dataLayer.push(arguments)
}

// window.Monitor comes from m.js, which loads async near the end of the body - later
// than any beacon rendered inside the page, so firing straight away would silently
// drop the conversion. Wait for it, but give up rather than poll forever.
const MONITOR_POLL_MS = 100
const MONITOR_TIMEOUT_MS = 10_000

const whenMonitorReady = (callback) => {
  if (typeof window.Monitor !== "undefined") {
    callback()
    return
  }

  const startedAt = Date.now()

  const timer = setInterval(() => {
    if (typeof window.Monitor !== "undefined") {
      clearInterval(timer)
      callback()
    } else if (Date.now() - startedAt > MONITOR_TIMEOUT_MS) {
      clearInterval(timer)
    }
  }, MONITOR_POLL_MS)
}

// YouLead form-conversion beacon. m.js is only present on prod/beta, so elsewhere
// this gives up after the timeout.
export const trackYouLeadForm = (formId, params) => {
  console.log(params)
  whenMonitorReady(() => {
    if (params) {
      window.Monitor.TrackForm(formId, params)
    } else {
      window.Monitor.TrackForm(formId)
    }
  })
}

// All YouLead push events go onto the ylData buffer that m.js drains.
const pushYlData = (entry) => {
  window.ylData = window.ylData || []
  window.ylData.push(entry)
}

// YouLead in-page navigation (hash links).
export const trackYouLeadPage = (value) => {
  pushYlData({ page: { extendedValue: value } })
}

// YouLead product view — products is an array of YouLead product ids.
export const trackYouLeadProduct = (products) => {
  pushYlData({ product: { products } })
}

// YouLead add-to-cart — products is an array of { productId, quantity, price }.
export const trackYouLeadCart = (products) => {
  pushYlData({ "cart.add": { products } })
}

// YouLead custom event — params (a string) is optional.
export const trackYouLeadEvent = (eventName, params) => {
  pushYlData({
    event: params === undefined ? { eventName } : { eventName, params },
  })
}

// Default fan-out: send an event to the GTM dataLayer and Hotjar.
export const track = (event, params = {}) => {
  trackGtm(event, params)
  trackHotjar(event)
}

// Exposed for inline scripts in ERB views, which can't import ES modules.
window.trackEvent = track
window.trackGa4 = trackGa4
window.trackYouLeadForm = trackYouLeadForm
